import React, {memo} from 'react';

import {
  convertLocationParamsToFetchParams,
  useProcedures,
} from 'app/procedures/api';
import {useAddProceduresToTeam} from 'app/teams/api';

import {AddNewTeamDocButton} from '../components/AddNewTeamDocButton';

import type {OverlayPlacementType} from 'app/general/overlays';
import type {ProceduresFetchParamsType} from 'app/procedures/types';
import type {ProcedureSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  buttonClass?: string;
  placement?: OverlayPlacementType;
  team: TeamSerializedType;
};

export const AddNewTeamProcedureButton = memo<Props>(
  ({team, buttonClass, placement}: Props) => {
    const [addToTeam] = useAddProceduresToTeam();

    return (
      <AddNewTeamDocButton<ProcedureSerializedType, ProceduresFetchParamsType>
        team={team}
        buttonClass={buttonClass}
        placement={placement}
        contentType="procedure"
        addAction={addToTeam}
        useDataHook={useProcedures}
        paramsConverter={convertLocationParamsToFetchParams}
      />
    );
  }
);
